module.exports = __webpack_public_path__ + "static/media/brand-kit.32addc00.png";